/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCatalogConfig } from '../../models/api-response-catalog-config';
import { CatalogConfig } from '../../models/catalog-config';

export interface UpdateCatalogConfig$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: CatalogConfig
}

export function updateCatalogConfig(http: HttpClient, rootUrl: string, params: UpdateCatalogConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCatalogConfig>> {
  const rb = new RequestBuilder(rootUrl, updateCatalogConfig.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCatalogConfig>;
    })
  );
}

updateCatalogConfig.PATH = '/v1/api/ui/company/catalog-config';
